import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  BODY_PARTS_OPTIONS,
  BODY_PARTS_QUESTION,
  SECTION_NUMBER,
} from '~/pages/anatomyV2/bodyParts/libs/components/AnatomyV2BodyParts/constants'
import { AnatomyV2BodyPartsStyles as S } from '~/pages/anatomyV2/bodyParts/libs/components/AnatomyV2BodyParts/styles'
import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const AnatomyV2BodyParts = ({ pageId, nextPagePath }: TPageProps) => {
  useMatchHeaderBackground()

  const { t } = useTranslation('anatomyV2')
  const [answers, setAnswers] = useState<string[]>([])

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: BODY_PARTS_QUESTION,
  })

  const handleOptionToggle = (key: string) => {
    setAnswers((prev) =>
      prev.includes(key)
        ? prev.filter((answer) => answer !== key)
        : [...prev, key],
    )
  }

  return (
    <S.Root>
      <S.ContentWrapper>
        <SectionProgress currentSection={SECTION_NUMBER} pageId={pageId} />

        <S.ScrollContent>
          <S.Title>
            <Trans ns="anatomyV2" i18nKey="onboarding.bodyParts.title" />
          </S.Title>

          <S.Grid>
            {BODY_PARTS_OPTIONS.map(({ key, i18nKey, png, webp }) => (
              <S.OptionCard
                key={key}
                type="button"
                $isSelected={answers.includes(key)}
                onClick={() => handleOptionToggle(key)}
              >
                <S.CardImage>
                  <picture>
                    <source srcSet={webp} type="image/webp" />
                    <img src={png} alt={t(i18nKey)} />
                  </picture>
                </S.CardImage>
                <S.CardLabel>{t(i18nKey)}</S.CardLabel>
              </S.OptionCard>
            ))}
          </S.Grid>
        </S.ScrollContent>

        <S.StyledButton
          type="button"
          disabled={!answers.length}
          onClick={() => handleContinue(answers)}
        >
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AnatomyV2BodyParts
